module.exports = __webpack_public_path__ + "media/images/common/ico-lp-about-anywhere-6bea7c57a192484473e999f26f4e58b3.svg";